module.exports = new __parcel__URL__("MMIRL6.c5b24fbb.jpg").toString();